import '../Scss/lin_insights.scss';
import CardsLayout, {SELECTORS as CARDS_LAYOUT} from '../../Components/CardsLayout/CardsLayout';
import Filter, {SELECTORS as FILTER} from '../../Components/Filter/Filter';

import '../../Components/Tracking/Tracking';

export const SELECTORS = {
    root:               '.js-content-hub',
    form:               '.js-content-hub-filter',
    teaser:             '.js-content-hub-filter-teaser',
    teaserSubmit:       '.js-content-hub-filter-teaser-submit',
    cardsWrapper:       '.js-content-hub-wrapper',
    cards:              '.js-content-hub-item',
    loadMore:           '.js-content-hub-loadmore',
    loadMoreWrapper:    '.js-content-hub-loadmore-wrapper',
};

const updateConsentManager = () => {
    if(typeof __cmp !== "function") {
        console.error("ConsentManager is not defined as a global variable. This could affect the visibility of blocked content.");
        return;
    }

    __cmp("checkBlocking");
}

document.addEventListener('DOMContentLoaded', _ => {

    $(CARDS_LAYOUT.root).each((i, cardslayout) => {
        if ($(SELECTORS.cards).length > 0) {
            new CardsLayout(cardslayout);
        }
    });

    $(FILTER.categories).each((i, filter) => {
        new Filter(filter);
    });

    // form submit ajax call
    $(SELECTORS.form).not(SELECTORS.teaser).on('submit', function (e) {
        e.preventDefault();

        $(CARDS_LAYOUT.elementWrapper).removeClass('initial');
        $(CARDS_LAYOUT.elementWrapper).removeClass('show');

        $(SELECTORS.loadMoreWrapper).remove();

        let $url = $(this).attr('action');
        let $data = $(this).serialize();

        $.ajax({
            method: 'POST',
            url: $url,
            cache: false,
            data: $data,
            success: function (result) {
                $(SELECTORS.cardsWrapper).html(result);
                $(CARDS_LAYOUT.root).each((i, cardslayout) => {
                    new CardsLayout(cardslayout);
                });

                setTimeout(_ => {
                    $(CARDS_LAYOUT.elementWrapper).addClass('show');
                }, 150);

                if($(SELECTORS.loadMoreWrapper).length > 0) {
                    setTimeout(_ => {
                        $(SELECTORS.loadMoreWrapper).appendTo(SELECTORS.root);
                    }, 500);
                }

                updateConsentManager();
            }
        })
    });

    // load more ajax call
    $(SELECTORS.root).on('click', SELECTORS.loadMore, function (e) {
        e.preventDefault();
        $(this).remove();

        let $url = $(SELECTORS.form).attr('action');
        let $data = $(SELECTORS.form).serializeArray();

        $data.push({
            name: "tx_lininsights_pi1[demand][offset]",
            value: $(this).attr('data-offset')
        });

        $.ajax({
            method: 'POST',
            url: $url,
            cache: false,
            data: $.param($data),
            success: function (result) {
                $(SELECTORS.cardsWrapper).append(result);
                $(CARDS_LAYOUT.root).each((i, cardslayout) => {
                    new CardsLayout(cardslayout);
                });
                if($(SELECTORS.loadMoreWrapper).length > 0) {
                    setTimeout(_ => {
                        $(SELECTORS.loadMoreWrapper).appendTo(SELECTORS.root);
                    }, 500);
                }

                updateConsentManager();
            }
        })
    });
});
